import type { FeedbackData } from '../types';

export const FeedbackApi = Symbol('FeedbackApi');

export interface FeedbackApi {
    feedbackPost<T>(feedbackData: FeedbackData<T>): Promise<boolean>;
}
